<template>
    <td-dialog
        :title="$t(title)"
        :before-close="dlalogImportClose"
        :visible.sync="isImportVisible"
        @cancel="dlalogImportClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :showCloseFoot="false"
        width="400px"
    >
        <el-form :inline="true" ref="fromOrgImport" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <el-form-item>
                <td-upload
                    :action="action"
                    :autoUpload="false"
                    ref="uploadOrgExport"
                    message="pgMessage.ZIP_FILE"
                    :multiple="false"
                    :limit="10"
                    :showFileList="true"
                    accept="zip"
                    :on-success="handResponse"
                    :on-error="handResponse"
                    :http-request="uploadOrgZip"
                ></td-upload>
            </el-form-item>
        </el-form>
    </td-dialog>
</template>
<script>
import importApi from './../assets/api.js';
export default {
    props: {
        title: {
            type: [String, Number]
        },
        // 页面是否显示
        isImportVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        fileParam: {
            type: Object
        },
        // 组织id
        orgId: {
            type: String
        }
    },
    computed: {},
    data() {
        return {
            action: '',
            fromOrgImport: {},
            loading: false
        };
    },
    methods: {
        uploadOrgZip(content) {
            this.loading = true;
            let file = new FormData();
            file.append('file', content.file);
            file.append('orgId', this.orgId);
            importApi.uploadOrgZip(file, response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/OrgManagerController/uploadOrgZip', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/OrgManagerController/uploadOrgZip', response.data.statusMessage);
                    return;
                }
                if (response.data.content) {
                    this.dlalogImportClose(response.data.content);
                    this.$emit('submit');
                    return;
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                this.dlalogImportClose();
                this.$emit('submit');
            });
        },

        // 导入
        handResponse(response) {
            this.loading = false;
            if (response.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.statusMessage, type: 'error' });
                this.$log.error('/device/importApi  ', response.statusMessage);
                return;
            }
            if (response.content) {
                this.$message({ showClose: true, message: response.content, type: 'error' });
                return;
            }
            this.$message({ showClose: true, message: response.statusMessage, type: 'success' });
        },

        dlalogImportClose(data) {
            this.$emit('dlalogImportClose', data);
        }
    }
};
</script>
<style>
.uploadStyle {
    text-align: center;
}
</style>
